import {
    Avatar,
    Badge,
    Card,
    Center,
    Group,
    Stack,
    Text
} from '@mantine/core';
import classes from './MessageCard.module.css';
import {
    Message,
    MessageStatus
} from "../../types.ts";
import {MessageToolbar} from "../MessageToolbar.tsx";
import {formatTimestamp} from "../../../../utils/TableTimestamps.tsx";
import {TagsGroup} from "../TagsGroup.tsx";
import {useMessage} from "../../hooks/useMessage.ts";


export function MessageCard({
                                record
                            }: {
    record: Message
}) {
    const { updateRecord } = useMessage(record.id);

    const handleRemoveTag = (tagId: string) => {
        const updatedTagIds = record.tagIds?.filter(id => id !== tagId) || [];
        const updatedRecord = { ...record, tagIds: updatedTagIds };
        updateRecord(updatedRecord);
    };


    return (
        <Card withBorder padding="xl" radius="md" className={classes.card}>
            <Card.Section
                className={classes.banner}
                h={100}
            />
            <Avatar
                name={record.subject}
                size={80}
                radius={80}
                mx="auto"
                mt={-30}
                className={classes.avatar}
            />
            <Center mt={'sm'}>
                <Stack>
                    <Group gap={'sm'}>
                        <Text c="dimmed">{formatTimestamp(record.date as string)}</Text>
                    </Group>
                    <Group gap={'sm'}>
                        <Text ta="center" fz="lg" fw={500} c={'dimmed'}>
                            Status:</Text>
                        <Badge variant={'outline'}
                               color={record.status === MessageStatus.READ ? 'green' : 'orange'}>{record.status}</Badge>
                    </Group>
                </Stack>
            </Center>
            <MessageToolbar record={record}/>
            {record.tags?.items && record.tags?.items.length > 0 ? <Card.Section className={classes.section}>
                <TagsGroup value={record.tags?.items} onRemove={handleRemoveTag}/>
            </Card.Section> : null}
        </Card>
    );
}